<template>
	<Page>
		<template #image><FailureIcon /></template>
		<template #default>{{ message }}</template>
	</Page>
</template>

<script setup lang="ts">
import Page from '@/components/ui/Page.vue';
import { WEBAPP_API_MIN_VERSION } from '@/constants';
import { useRoute } from 'vue-router';
import FailureIcon from '@/assets/icons/failure.svg?component';

const route = useRoute();

const message = route.query.message || `Wallet supported only on telegram api v${WEBAPP_API_MIN_VERSION}`;
</script>
